import { Box } from "@mui/material"
import SchoolProfileChild from "app/modules/schools/pages/SchoolProfile/SchoolProfileChild"



import React from 'react'

const SchoolsSetting = () => {
  return (
    <Box sx={{ py: 2 }}>
      <SchoolProfileChild />
    </Box>
  )
}

export default SchoolsSetting